<div v-if="shouldRenderConfig && getShowAddToCart" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" 
        ref="addToCartBtn" 
        v-bind:class="getDisableClass"
        v-on:click="onClickAddToCart">
        {{ $t('Add to Cart') }}
    </button>    
</div>

